import type { ClaimTask, TaskDetail } from '../types';

export const tasks: ClaimTask[] = [
  {
    id: 'task-1',
    assignedTo: 'Marie Dupont',
    startDate: '2024-01-15',
    client: 'Jean Martin',
    dossierNumber: 'DOS-2024-0142',
    nature: 'reception_rapport',
    taskLabel: 'Traitement du rapport',
  },
  {
    id: 'task-2',
    assignedTo: 'Pierre Lambert',
    startDate: '2024-01-14',
    client: 'Sophie Bernard',
    dossierNumber: 'DOS-2024-0138',
    nature: 'mise_en_cause',
    taskLabel: 'Mise en cause tiers',
  },
  {
    id: 'task-3',
    assignedTo: 'Marie Dupont',
    startDate: '2024-01-13',
    client: 'Luc Moreau',
    dossierNumber: 'DOS-2024-0135',
    nature: 'reception_rapport',
    taskLabel: 'Traitement du rapport',
  },
  {
    id: 'task-4',
    assignedTo: 'Claire Rousseau',
    startDate: '2024-01-12',
    client: 'Emma Petit',
    dossierNumber: 'DOS-2024-0129',
    nature: 'ouverture_sinistre',
    taskLabel: 'Ouverture de sinistre',
  },
  {
    id: 'task-5',
    assignedTo: 'Pierre Lambert',
    startDate: '2024-01-11',
    client: 'Thomas Leroy',
    dossierNumber: 'DOS-2024-0125',
    nature: 'cloture_dossier',
    taskLabel: 'Clôture du dossier',
  },
  {
    id: 'task-6',
    assignedTo: 'Claire Rousseau',
    startDate: '2024-01-10',
    client: 'Julie Blanc',
    dossierNumber: 'DOS-2024-0118',
    nature: 'reception_rapport',
    taskLabel: 'Traitement du rapport',
  },
  {
    id: 'task-7',
    assignedTo: 'Marie Dupont',
    startDate: '2024-01-16',
    client: 'Pierre Duval',
    dossierNumber: 'DOS-2024-0145',
    nature: 'suivi',
    taskLabel: 'Suivi du dossier',
  },
  {
    id: 'task-8',
    assignedTo: 'Pierre Lambert',
    startDate: '2024-01-17',
    client: 'Marc Lefèvre',
    dossierNumber: 'DOS-2024-0150',
    nature: 'action_libre',
    taskLabel: 'Action libre',
  },
];

export const taskDetails: Record<string, TaskDetail> = {
  'task-1': {
    task: tasks[0]!,
    claim: {
      client: 'Jean Martin',
      dossierNumber: 'DOS-2024-0142',
      date: '2024-01-10',
      openingDate: '2024-01-11',
      status: 'Ouvert',
      materialManager: 'Marie Dupont',
      bodilyManager: '-',
      plate: 'AB-123-CD',
      location: 'Péage de Fleury-en-Bière (A6)',
      responsibility: '100%',
      type: 'IDA',
      article: '50 / Y ne respecte pas un feu rouge fixe ou clignotant',
      collisionType: 'Collision contre un véhicule',
      company: 'Howden',
      damageNature: 'Matériel',
      thirdParty: 'Leo Martin',
      description:
        'Collision arrière sur autoroute A6. Véhicule tamponné à l\u2019arrêt au péage.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: null,
        settlement: null,
        grossCharge: null,
        forecast: null,
        recourse: null,
        cost: null,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 1200,
        settlement: null,
        grossCharge: 1200,
        forecast: 1200,
        recourse: null,
        cost: 1200,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 1200,
    documents: [
      {
        id: 'doc-1',
        name: 'Rapport d\u2019expertise',
        type: 'Rapport',
        isNew: true,
        isActive: true,
      },
      {
        id: 'doc-2',
        name: 'Constat amiable',
        type: 'Constat',
        isNew: false,
        isActive: false,
      },
      {
        id: 'doc-3',
        name: 'Photos véhicule',
        type: 'Photos',
        isNew: false,
        isActive: false,
      },
      {
        id: 'doc-4',
        name: 'Email de l\u2019expert',
        type: 'Correspondance',
        isNew: true,
        isActive: false,
      },
    ],
  },
  'task-2': {
    task: tasks[1]!,
    claim: {
      client: 'Sophie Bernard',
      dossierNumber: 'DOS-2024-0138',
      date: '2024-01-08',
      openingDate: '2024-01-09',
      status: 'En cours',
      materialManager: 'Pierre Lambert',
      bodilyManager: 'Claire Rousseau',
      plate: 'EF-456-GH',
      location: 'Carrefour Bd Haussmann / Rue de Rome, Paris',
      responsibility: '50%',
      type: 'IDA',
      article: '32 / Deux véhicules circulant en sens inverse',
      collisionType: 'Collision frontale',
      company: 'AXA',
      damageNature: 'Matériel et corporel',
      thirdParty: 'Marc Petit',
      description:
        'Collision frontale au carrefour. Refus de priorité par le tiers.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: 3500,
        settlement: null,
        grossCharge: 3500,
        forecast: 3500,
        recourse: 1750,
        cost: 1750,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 800,
        settlement: null,
        grossCharge: 800,
        forecast: 800,
        recourse: null,
        cost: 800,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 2550,
    documents: [
      {
        id: 'doc-5',
        name: 'Constat amiable',
        type: 'Constat',
        isNew: false,
        isActive: true,
      },
      {
        id: 'doc-6',
        name: 'Photos véhicule',
        type: 'Photos',
        isNew: false,
        isActive: false,
      },
    ],
  },
  'task-3': {
    task: tasks[2]!,
    claim: {
      client: 'Luc Moreau',
      dossierNumber: 'DOS-2024-0135',
      date: '2024-01-06',
      openingDate: '2024-01-07',
      status: 'Ouvert',
      materialManager: 'Marie Dupont',
      bodilyManager: '-',
      plate: 'IJ-789-KL',
      location: 'Parking Centre Commercial Les Halles, Paris',
      responsibility: '0%',
      type: 'IDA',
      article: '51 / Y heurte un autre véhicule à l\u2019arrêt',
      collisionType: 'Collision en stationnement',
      company: 'Generali',
      damageNature: 'Matériel',
      thirdParty: 'Anne Dubois',
      description:
        'Véhicule heurté en stationnement par un tiers en manoeuvre de recul.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: null,
        settlement: null,
        grossCharge: null,
        forecast: null,
        recourse: null,
        cost: null,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 950,
        settlement: null,
        grossCharge: 950,
        forecast: 950,
        recourse: 950,
        cost: 0,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 0,
    documents: [
      {
        id: 'doc-7',
        name: 'Rapport d\u2019expertise',
        type: 'Rapport',
        isNew: true,
        isActive: true,
      },
      {
        id: 'doc-8',
        name: 'Constat amiable',
        type: 'Constat',
        isNew: false,
        isActive: false,
      },
      {
        id: 'doc-9',
        name: 'Devis réparation',
        type: 'Devis',
        isNew: false,
        isActive: false,
      },
    ],
  },
  'task-4': {
    task: tasks[3]!,
    claim: {
      client: 'Emma Petit',
      dossierNumber: 'DOS-2024-0129',
      date: '2024-01-04',
      openingDate: '2024-01-05',
      status: 'Ouvert',
      materialManager: 'Claire Rousseau',
      bodilyManager: '-',
      plate: 'MN-012-OP',
      location: 'Avenue des Champs-Élysées, Paris',
      responsibility: '100%',
      type: 'IDA',
      article: '22 / Y change de file',
      collisionType: 'Collision latérale',
      company: 'Allianz',
      damageNature: 'Matériel',
      thirdParty: 'Paul Garnier',
      description:
        'Changement de file sans vérification. Impact latéral avec le véhicule tiers.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: 2000,
        settlement: null,
        grossCharge: 2000,
        forecast: 2000,
        recourse: null,
        cost: 2000,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 1500,
        settlement: null,
        grossCharge: 1500,
        forecast: 1500,
        recourse: null,
        cost: 1500,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 3500,
    documents: [
      {
        id: 'doc-10',
        name: 'Déclaration de sinistre',
        type: 'Déclaration',
        isNew: false,
        isActive: true,
      },
    ],
  },
  'task-5': {
    task: tasks[4]!,
    claim: {
      client: 'Thomas Leroy',
      dossierNumber: 'DOS-2024-0125',
      date: '2024-01-02',
      openingDate: '2024-01-03',
      status: 'Clôturé',
      materialManager: 'Pierre Lambert',
      bodilyManager: '-',
      plate: 'QR-345-ST',
      location: 'Route Nationale 7, Fontainebleau',
      responsibility: '0%',
      type: 'IDA',
      article: '41 / Y heurte l\u2019arrière de X',
      collisionType: 'Collision arrière',
      company: 'MAIF',
      damageNature: 'Matériel',
      thirdParty: 'Julien Morel',
      description:
        'Tamponné par l\u2019arrière à un feu rouge. Aucune responsabilité de l\u2019assuré.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: null,
        settlement: null,
        grossCharge: null,
        forecast: null,
        recourse: null,
        cost: null,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 600,
        settlement: 600,
        grossCharge: 600,
        forecast: 600,
        recourse: 600,
        cost: 0,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 0,
    documents: [
      {
        id: 'doc-11',
        name: 'Rapport d\u2019expertise',
        type: 'Rapport',
        isNew: false,
        isActive: true,
      },
      {
        id: 'doc-12',
        name: 'Constat amiable',
        type: 'Constat',
        isNew: false,
        isActive: false,
      },
      {
        id: 'doc-13',
        name: 'Facture réparation',
        type: 'Facture',
        isNew: false,
        isActive: false,
      },
    ],
  },
  'task-6': {
    task: tasks[5]!,
    claim: {
      client: 'Julie Blanc',
      dossierNumber: 'DOS-2024-0118',
      date: '2023-12-28',
      openingDate: '2023-12-29',
      status: 'Ouvert',
      materialManager: 'Claire Rousseau',
      bodilyManager: '-',
      plate: 'UV-678-WX',
      location: 'Rond-point de la Défense, Puteaux',
      responsibility: '50%',
      type: 'IDA',
      article: '12 / Collision dans un rond-point',
      collisionType: 'Collision en giratoire',
      company: 'Swiss Life',
      damageNature: 'Matériel',
      thirdParty: 'Camille Roux',
      description:
        'Collision dans le giratoire. Responsabilité partagée entre les deux conducteurs.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: 1100,
        settlement: null,
        grossCharge: 1100,
        forecast: 1100,
        recourse: 550,
        cost: 550,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 700,
        settlement: null,
        grossCharge: 700,
        forecast: 700,
        recourse: null,
        cost: 700,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 1250,
    documents: [
      {
        id: 'doc-14',
        name: 'Rapport d\u2019expertise',
        type: 'Rapport',
        isNew: true,
        isActive: true,
      },
      {
        id: 'doc-15',
        name: 'Photos véhicule',
        type: 'Photos',
        isNew: false,
        isActive: false,
      },
    ],
  },
  'task-7': {
    task: tasks[6]!,
    claim: {
      client: 'Pierre Duval',
      dossierNumber: 'DOS-2024-0145',
      date: '2024-01-12',
      openingDate: '2024-01-13',
      status: 'En cours',
      materialManager: 'Marie Dupont',
      bodilyManager: 'Pierre Lambert',
      plate: 'YZ-901-AB',
      location: 'Boulevard Périphérique, Porte de Vincennes',
      responsibility: '100%',
      type: 'IDA',
      article: '13 / Y ne respecte pas une priorité à droite',
      collisionType: 'Collision en intersection',
      company: 'Groupama',
      damageNature: 'Matériel et corporel',
      thirdParty: 'Nathalie Simon',
      description:
        'Non-respect de la priorité à droite. Collision au carrefour avec blessure légère du tiers.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: 5000,
        settlement: null,
        grossCharge: 5000,
        forecast: 5000,
        recourse: null,
        cost: 5000,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 2200,
        settlement: null,
        grossCharge: 2200,
        forecast: 2200,
        recourse: null,
        cost: 2200,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 7200,
    documents: [
      {
        id: 'doc-16',
        name: 'Constat amiable',
        type: 'Constat',
        isNew: false,
        isActive: true,
      },
      {
        id: 'doc-17',
        name: 'Certificat médical',
        type: 'Médical',
        isNew: true,
        isActive: false,
      },
    ],
  },
  'task-8': {
    task: tasks[7]!,
    claim: {
      client: 'Marc Lefèvre',
      dossierNumber: 'DOS-2024-0150',
      date: '2024-01-15',
      openingDate: '2024-01-16',
      status: 'Ouvert',
      materialManager: 'Pierre Lambert',
      bodilyManager: '-',
      plate: 'CD-234-EF',
      location: 'Rue de Rivoli, Paris 1er',
      responsibility: '0%',
      type: 'IDA',
      article: '51 / Y heurte l\u2019arrière de X',
      collisionType: 'Collision arrière',
      company: 'MMA',
      damageNature: 'Matériel',
      thirdParty: 'Isabelle Fournier',
      description:
        'Tamponné par l\u2019arrière en circulation dense. Dommages légers au pare-chocs.',
    },
    costs: [
      {
        guarantee: 'RC',
        provision: null,
        settlement: null,
        grossCharge: null,
        forecast: null,
        recourse: null,
        cost: null,
        isTotal: true,
        poste: 'TOTAL',
      },
      {
        guarantee: 'Dommages',
        provision: 450,
        settlement: null,
        grossCharge: 450,
        forecast: 450,
        recourse: 450,
        cost: 0,
        isTotal: true,
        poste: 'TOTAL',
      },
    ],
    totalCost: 0,
    documents: [
      {
        id: 'doc-18',
        name: 'Constat amiable',
        type: 'Constat',
        isNew: false,
        isActive: true,
      },
    ],
  },
};

/**
 * Lookup a task detail by task ID. Returns undefined if not found.
 */
export function getTaskDetail(taskId: string): TaskDetail | undefined {
  return taskDetails[taskId];
}

/**
 * Format a date string (ISO) to French short format: "15 janv. 2024"
 */
export function formatDateFr(isoDate: string): string {
  const date = new Date(isoDate);
  return date.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Format a number as French currency: "1 200,00 \u20ac"
 */
export function formatCurrencyFr(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}
